import { render, staticRenderFns } from "./ProductionTaskCard.vue?vue&type=template&id=08fd3511&scoped=true&"
import script from "./ProductionTaskCard.vue?vue&type=script&lang=ts&"
export * from "./ProductionTaskCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProductionTaskCard.vue?vue&type=style&index=0&id=08fd3511&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fd3511",
  null
  
)

export default component.exports